import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import SEO from "@/components/SEO";
import PreventivoWizard from "@/components/PreventivoWizard";

export default function RichiestaPreventivo() {
    return (
        <>
            <SEO
                title="Richiedi Preventivo · Wizard guidato"
                description="Preventivo personalizzato in 5 passi: settore, partecipanti, corso, location, contatti. Risposta entro 24 ore. Senza impegno."
                path="/richiesta-preventivo"
                keywords="preventivo corso BLS-AED, richiedi preventivo formazione aziendale, preventivo defibrillatore noleggio"
                breadcrumbs={[{ name: "Home", path: "/" }, { name: "Richiedi preventivo", path: "/richiesta-preventivo" }]}
            />
            <section className="bg-ink text-white">
                <div className="container-7m py-12 sm:py-16 lg:py-20">
                    <div className="max-w-3xl">
                        <div className="label-eyebrow !text-brand">Preventivo guidato</div>
                        <h1 className="mt-3 font-heading font-black text-3xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
                            Trova il corso perfetto<br />
                            <span className="text-brand">per la tua azienda.</span>
                        </h1>
                        <p className="mt-5 text-base sm:text-lg text-white/80 max-w-xl leading-relaxed">
                            Rispondi a poche domande e ricevi un preventivo personalizzato entro 24 ore.
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-10 sm:py-14 lg:py-20 bg-white">
                <div className="container-7m max-w-4xl mx-auto">
                    <PreventivoWizard idPrefix="wizard-page" />
                    <div className="mt-12 pt-8 border-t border-ink/10 text-center text-sm text-ink-muted">
                        Preferisci parlare con noi? <Link to="/contatti" className="text-brand underline">Contattaci direttamente →</Link>
                    </div>
                </div>
            </section>
        </>
    );
}

// Re-export for compatibility if any other file imports the icon helpers
export { CheckCircle2 };
